import {  Container } from '@mui/material'
import { FC, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useParams } from 'react-router-dom'
import { AppDispatch } from '../../store'
import { UrlMapSelectors } from '../../store/urlMaps/urlMap..selector'
import { UrlMapActions } from '../../store/urlMaps/urlMap.slice'
import { RedirectError } from './RedirectError'
import { Backdrop } from '../../components/Backdrop'

export const RedirectMain: FC = () => {
  const params = useParams()
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const isLoading = useSelector(UrlMapSelectors.loading)
  const isError = useSelector(UrlMapSelectors.error)
  const data = useSelector(UrlMapSelectors.data)
  const handleGetRedirect = useCallback(
    async (code) => {
      const urlMap = await dispatch(UrlMapActions.GetUrlMapAsync(code, {}))
      if (UrlMapActions.GetUrlMapAsync.fulfilled.match(urlMap)) {
        window.open(urlMap.payload.originalUrl, '_self')
      }
      if (UrlMapActions.GetUrlMapAsync.rejected.match(urlMap)) {
      }
    },
    [dispatch],
  )
  useEffect(() => {
    if (params.id) {
      handleGetRedirect(params.id)
    }
  }, [])
  return (
    <Container
      maxWidth="lg"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        p: 4,
      }}
    >

      {isLoading && <Backdrop/>}
      {isError && <RedirectError />}

    </Container>
  )
}
